import VariantSelects from "@theme/variant-selects";
class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.bundleInput = this.querySelector("[data-bundle-qty]");
    if (this.bundleInput) {
      this.bundleQty = parseInt(this.bundleInput.dataset.bundleQty, 10);
      this.updateBundleOptionPrice();
    }
  }
  updateBundleOptionPrice() {
    const discount = window.bundle_discounts?.[`bundle:${this.bundleQty}`] || 0;
    if (discount <= 0) return;
    const variants = this.getVariantData();
    const pcsVariant = variants.find(
      (v) => v.options.includes(this.bundleInput.value)
    );
    if (!pcsVariant) return;
    const totalPrice = pcsVariant.price * this.bundleQty;
    const discountedPrice = Math.round(totalPrice * (1 - discount / 100));
    const label = this.bundleInput.nextElementSibling;
    const priceSpan = label?.querySelector(".mt-1");
    if (priceSpan) {
      priceSpan.innerHTML = `<span class="line-through opacity-40">${this.formatMoney(totalPrice)}</span> ${this.formatMoney(discountedPrice)}`;
    }
  }
  get quantityInput() {
    const section = this.closest("section") || this.closest(".shopify-section");
    return section?.querySelector(".quantity-input");
  }
  onVariantChange() {
    if (this.bundleInput) {
      const qtyInput = this.quantityInput;
      if (this.bundleInput.checked) {
        if (qtyInput) {
          qtyInput.value = this.bundleQty;
          qtyInput.dispatchEvent(new Event("change"));
        }
      } else if (qtyInput && parseInt(qtyInput.value, 10) === this.bundleQty) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event("change"));
      }
    }
    super.onVariantChange();
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection || this.dataset.section}`
    ).then((response) => response.text()).then((responseText) => {
      const html = new window.DOMParser().parseFromString(responseText, "text/html");
      const destination = document.getElementById(`price-${this.dataset.section}`);
      const source = html.getElementById(
        `price-${this.dataset.originalSection || this.dataset.section}`
      );
      if (source && destination) destination.innerHTML = source.innerHTML;
      if (this.bundleInput?.checked) {
        this.renderBundlePrice(destination);
      }
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.remove("invisible");
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );
      document.dispatchEvent(new CustomEvent("variant:change", {
        detail: {
          sectionId: this.dataset.section,
          variantId: this.currentVariant.id,
          available: this.currentVariant.available
        }
      }));
    });
  }
  multiplyPrices(container) {
    if (!container) return;
    const priceEl = container.querySelector(".product-price");
    const compareEl = container.querySelector(".product-compare-price");
    if (priceEl) this.multiplyTextNodes(priceEl);
    if (compareEl) this.multiplyTextNodes(compareEl);
  }
  multiplyTextNodes(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while (node = walker.nextNode()) {
      const text = node.textContent;
      node.textContent = text.replace(/(\d[\d.,]*\d|\d)/g, (match) => {
        let amount;
        if (match.includes(",") && match.includes(".")) {
          amount = parseFloat(match.replace(/\./g, "").replace(",", "."));
        } else if (match.includes(",")) {
          amount = parseFloat(match.replace(",", "."));
        } else {
          amount = parseFloat(match);
        }
        if (isNaN(amount)) return match;
        const total = (amount * this.bundleQty).toFixed(2);
        return total.replace(".", match.includes(",") ? "," : ".");
      });
    }
  }
  multiplyMoneyText(text) {
    const cleaned = text.replace(/[^\d.,]/g, "").trim();
    if (!cleaned) return text;
    let amount;
    if (cleaned.includes(",") && cleaned.includes(".")) {
      amount = parseFloat(cleaned.replace(/\./g, "").replace(",", "."));
    } else if (cleaned.includes(",") && !cleaned.includes(".")) {
      amount = parseFloat(cleaned.replace(",", "."));
    } else {
      amount = parseFloat(cleaned);
    }
    if (isNaN(amount)) return text;
    const total = (amount * this.bundleQty).toFixed(2);
    return text.replace(cleaned, total.replace(".", cleaned.includes(",") ? "," : "."));
  }
  renderBundlePrice(container) {
    if (!container || !this.currentVariant) return;
    const discount = window.bundle_discounts?.[`bundle:${this.bundleQty}`] || 0;
    const unitPrice = this.currentVariant.price;
    const totalPrice = unitPrice * this.bundleQty;
    const compareAt = this.currentVariant.compare_at_price;
    const wrapper = container.querySelector(".product-price-wrapper");
    if (!wrapper) return;
    if (discount > 0) {
      const discountedPrice = Math.round(totalPrice * (1 - discount / 100));
      const compareTotal = compareAt && compareAt > unitPrice ? compareAt * this.bundleQty : totalPrice;
      wrapper.innerHTML = `
        <span class="product-price text-2xl font-semibold">${this.formatMoney(discountedPrice)}</span>
        <span class="product-compare-price text-lg line-through opacity-60">${this.formatMoney(compareTotal)}</span>
        <span class="product-badge product-badge--discount bg-notice text-xxs inline-block rounded-full px-2 py-1 font-semibold text-white sm:px-3 sm:text-sm">- ${Math.round((compareTotal - discountedPrice) / compareTotal * 100)}%</span>
      `;
    } else {
      this.multiplyPrices(container);
    }
  }
  formatMoney(cents) {
    if (window.money_format) {
      const amount = (cents / 100).toFixed(2);
      return window.money_format.replace("{{amount}}", amount).replace("{{amount_no_decimals}}", Math.floor(cents / 100)).replace(
        "{{amount_with_comma_separator}}",
        amount.replace(".", ",")
      );
    }
    const currency = window.Shopify?.currency?.active || "EUR";
    const locale = window.Shopify?.locale || "en-US";
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency
    }).format(cents / 100);
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
window.customElements.define("variant-radios", VariantRadios);
